(() => {
  const selector = '[data-cng-sale-badge], [data-cng-sale-discount], [data-cng-standard-offer], [data-cng-sale-popup], [data-cng-sale-hero], [data-cng-sale-state]';
  const maxTimerDelay = 2147483647;
  let timer;
  let observerQueued = false;

  function timestamp(value) {
    if (!/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.\d+)?(?:Z|[+-]\d\d:\d\d)$/.test(value || '')) return NaN;
    const parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  function updateBadge(badge, now) {
    const start = timestamp(badge.getAttribute('data-sale-start'));
    const end = timestamp(badge.getAttribute('data-sale-end'));
    const valid = Number.isFinite(start) && Number.isFinite(end) && start < end;
    const active = valid && start <= now && now < end;

    if (badge.matches('[data-cng-sale-state]')) {
      badge.dispatchEvent(new CustomEvent('cng:sale-state-changed', { detail: { active } }));
    } else if (badge.matches('[data-cng-sale-hero]')) {
      const showPublic = badge.getAttribute('data-sale-enabled') === 'true' && valid && now >= start;
      badge.querySelector('[data-cng-community-hero]').hidden = showPublic;
      badge.querySelector('[data-cng-public-hero]').hidden = !showPublic;
    } else if (badge.matches('[data-cng-sale-popup]')) {
      badge.classList.toggle('cng-sale-active', active);
      badge.dispatchEvent(new CustomEvent('cng:sale-state-changed', { detail: { active } }));
    } else if (badge.matches('[data-cng-standard-offer]')) {
      badge.classList.toggle('cng-offer-hidden', active);
    } else {
      if (active) {
        badge.removeAttribute('hidden');
        badge.classList.add('cng-badge--visible');
      } else {
        badge.setAttribute('hidden', '');
        badge.classList.remove('cng-badge--visible');
      }
    }
    return valid ? [start, end] : [];
  }

  function sync() {
    clearTimeout(timer);
    const now = Date.now();
    let nextBoundary = Infinity;

    document.querySelectorAll(selector).forEach((badge) => {
      updateBadge(badge, now).forEach((boundary) => {
        if (boundary > now && boundary < nextBoundary) nextBoundary = boundary;
      });
    });

    const delay = nextBoundary < Infinity ? Math.min(nextBoundary - now, maxTimerDelay, 10000) : 10000;
    timer = setTimeout(sync, delay);
  }

  document.addEventListener('visibilitychange', sync);
  new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
    ));
    if (relevant && !observerQueued) {
      observerQueued = true;
      queueMicrotask(() => {
        observerQueued = false;
        sync();
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();
})();
